import React from "react";

import { Link } from "react-router-dom";

import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";

// Error 404 image asset
import FourFour from "../../Assets/img/404.svg";

const Four = () => (
  <div className="page four">
    <Container
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-evenly",
      }}
    >
      <div>
        <Typography variant="h1">oops!</Typography>
        <Typography>The page you are looking for could not be found</Typography>
        <Link to="/Home" className="back-btn">
          Go Home
        </Link>
      </div>
      <img className="error_img" src={FourFour} alt="404" />
    </Container>
  </div>
);

export default Four;
